import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--lacotto-links"
export default class extends Controller {
  static values = {
    operation: String,
  };
  connect() {
    TurboStreamHeaders(this);
  }

  loadContent(e) {
    e.preventDefault();

    const params = { operation: this.operationValue };
    const query = new URLSearchParams(params).toString();

    fetch(`/lacotto_links?${query}`, {
      method: "GET",
      headers: {
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);

        const event = new CustomEvent("resumin--lacotto_links:loaded", {
          detail: { e: e },
        });

        this.element.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
